import {
    getNewReleasesListAdminAPI,
    getNewReleaseByIdAdminAPI,
    getNewReleaseByIdLabelAPI,
    changeReleaseStatusAdminAPI,
    rejectReleaseAudioAdminAPI,
    searchInReleasesAPI,
    ticketReasonsAdminAPI,
    deleteFileFromServerAPI,
    getUGCClaimOldAdminAPI,
    getUGCClaimRequestAdminAPI,
    getProfileLinkingRequestAdminAPI,
    getProfileLinkingOldAdminAPI,
    getPitchRequestAdminAPI,
    getPitchOldAdminAPI,
    updateUGCstatusAdminAPI,
    updateProfileLinkingstatusAdminAPI,
    updatePitchStatusAdminAPI,
    getVideoCatalogListAdminAPI,
    searchInVideoReleasesAPI,
    getSubLabelsAdminAPI,
    searchSubLabelsAdminAPI,
    addSubLabelAdminAPI,
    checkEmailExistsAdminAPI,
    b2bFileUploadAdminAPI
} from "./api"

export function getNewReleasesListAdmin(data) {
    return new Promise((resolve, reject) => {
        getNewReleasesListAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getNewReleaseByIdAdmin(data) {
    return new Promise((resolve, reject) => {
        getNewReleaseByIdAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getNewReleaseByIdLabel(data) {
    return new Promise((resolve, reject) => {
        getNewReleaseByIdLabelAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getUGCClaimOldAdmin(data) {
    return new Promise((resolve, reject) => {
        getUGCClaimOldAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getUGCClaimRequestAdmin(data) {
    return new Promise((resolve, reject) => {
        getUGCClaimRequestAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function searchInReleases(data) {
    return new Promise((resolve, reject) => {
        searchInReleasesAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function changeReleaseStatusAdmin(data) {
    return new Promise((resolve, reject) => {
        changeReleaseStatusAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function rejectReleaseAudioAdmin(data) {
    return new Promise((resolve, reject) => {
        rejectReleaseAudioAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function ticketReasonsAdmin(data) {
    return new Promise((resolve, reject) => {
        ticketReasonsAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function deleteFileFromServer(data) {
    return new Promise((resolve, reject) => {
        deleteFileFromServerAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getProfileLinkingRequestAdmin(data) {
    return new Promise((resolve, reject) => {
        getProfileLinkingRequestAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getProfileLinkingOldAdmin(data) {
    return new Promise((resolve, reject) => {
        getProfileLinkingOldAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getPitchRequestAdmin(data) {
    return new Promise((resolve, reject) => {
        getPitchRequestAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getPitchOldAdmin(data) {
    return new Promise((resolve, reject) => {
        getPitchOldAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function updateUGCstatusAdmin(data) {
    return new Promise((resolve, reject) => {
        updateUGCstatusAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function updateProfileLinkingstatusAdmin(data) {
    return new Promise((resolve, reject) => {
        updateProfileLinkingstatusAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function updatePitchStatusAdmin(data) {
    return new Promise((resolve, reject) => {
        updatePitchStatusAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getVideoCatalogListAdmin(data) {
    return new Promise((resolve, reject) => {
        getVideoCatalogListAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function searchInVideoReleases(data) {
    return new Promise((resolve, reject) => {
        searchInVideoReleasesAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getSubLabelsAdmin(data) {
    return new Promise((resolve, reject) => {
        getSubLabelsAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function searchSubLabelsAdmin(data) {
    return new Promise((resolve, reject) => {
        searchSubLabelsAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function addSubLabelAdmin(data) {
    return new Promise((resolve, reject) => {
        addSubLabelAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function checkEmailExistsAdmin(email) {
    return new Promise((resolve, reject) => {
        checkEmailExistsAdminAPI(email).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function b2bFileUploadAdmin(formData) {
    return new Promise((resolve, reject) => {
        b2bFileUploadAdminAPI(formData).then(res => resolve(res)).catch(err => reject(err))
    })
}